import { combineReducers } from "redux";

import user from "./user";
import openProtocolCustomer from "./openProtocolCustomer";
import openProtocolData from "./openProtocolData";
import customer from "./customer";
import card from "./card";
import slider from "./slider";
import customSlider from "./customSlider";
import title from "./title";
import toast from "./toast";
import blockedItemToast from "./blockedItemToast";
import tracking from "./tracking";
import quotesDashboard from "./quotesDashboard";
import quotesDetails from "./quotesDetails";
import quoteItem from "./quoteItem";
import quotesTableReload from "./quotesTableReload";
import protocol from "./protocol";
import download from "./download";
import enterpriseVips from "./enterpriseVips";
import unitPriceValue from "./unitPriceValue";
import currentTab from "./currentTab";
import updateBudgetSaved from "./updateBudgetSaved";
import resetBudget from "./resetBudget";
import savedBudgets from "./savedBudgets";
import budgets from "./budgets";
import quotesSentAnalyzed from "./quotesSentAnalyzed";
import eventsBanner from "./eventsBanner";
import toastify from "./toastify";
import downloadBar from './downloadBar';
import priorityItems from "./priorityItem";

export const rootReducer = combineReducers({
  openProtocolData,
  openProtocolCustomer,
  customer,
  tracking,
  user,
  card,
  slider,
  customSlider,
  toast,
  blockedItemToast,
  protocol,
  quotesDashboard,
  quotesDetails,
  title,
  download,
  quoteItem,
  enterpriseVips,
  quotesTableReload,
  unitPriceValue,
  currentTab,
  updateBudgetSaved,
  resetBudget,
  savedBudgets,
  budgets,
  quotesSentAnalyzed,
  eventsBanner,
  toastify,
  downloadBar,
  priorityItems
});

export type RootState = ReturnType<typeof rootReducer>;
